import React, { Fragment } from 'react';
import HighlightIcon from '../HighlightIcon';
import {
  CheckOutlined,
} from '@/components2/Icons';
export default function Vertical({
  highlights,
  facility,
  size = null,
  isCity,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);

  const getHighlight = (type) =>
    checkedHighlights.find((h) => h.type === type);

  const openHour = getHighlight('facility_open_hour');
  const accessibility = getHighlight('facility_accessibility');
  const freeCancellation = getHighlight('facility_free_cancellation');
  const notes = getHighlight('facility_additional_comments');
  const evCharger = getHighlight('facility_eletric_car');

  return (
    <>
      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4"
        {...props}
      >
        {isCity ?
          <>
            {openHour && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="open_hour"
                    width={16}
                    height={16}
                    stroke="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Facility Access
                </p>
                <p className="font-bold text-sm line-clamp-1">
                  {openHour.description}
                </p>
              </div>
            )}
            {accessibility && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="accessible"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Wheelchair Accessible
                </p>
              </div>
            )}
            {evCharger && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="eletric_car"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  EV Charger
                </p>
              </div>
            )}
            {freeCancellation && (
              <div className="flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <CheckOutlined className="text-green-600" />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap text-green-600 ml-2 mr-1">
                  Free Cancellation
                </p>
              </div>
            )}
            {notes && (
              <div className="md:col-span-2 flex flex-row flex-nowrap items-center">
                <div className="shrink-0">
                  <HighlightIcon
                    type="additional_comments"
                    width={16}
                    height={16}
                    fill="#434343"
                  />
                </div>
                <p className="text-sm text-center font-bold whitespace-nowrap ml-2 mr-1">
                  Notes
                </p>
                <p className="font-bold text-sm line-clamp-1">
                  {notes.description}
                </p>
              </div>
            )}
          </>
          :
          <>
            {checkedHighlights.map((highlight, index) => (
              <Fragment key={highlight.type + index}>
                {highlight.type === 'facility_free_cancellation' && (
                  <div className="flex flex-row gap-1 md:gap-2 items-center ">
                    <HighlightIcon
                      type="free-cancellations"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-xs md:text-sm text-center font-bold whitespace-nowrap">
                      Free Cancellation
                    </p>

                  </div>
                )}
                {highlight.type === 'facility_free_shuttles' && (
                  <div className="flex flex-row gap-1 md:gap-2 items-center ">
                    <HighlightIcon
                      type="free-shuttle"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-xs md:text-sm text-center font-bold whitespace-nowrap">
                      Free Shuttle
                    </p>

                  </div>
                )}
                {highlight.type === 'facility_no_shuttles' && (
                  <div className="flex flex-row gap-1 md:gap-2 items-center">
                    <HighlightIcon
                      type="no-free-shuttle"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-xs md:text-sm text-center font-bold whitespace-nowrap">
                      No Shuttle
                    </p>
                  </div>
                )}
              </Fragment>
            ))}
          </>
        }
      </div>
    </>
  );
}
